import { navButtonProps } from "./models/NavTextButton.model"
import { Nav } from "react-bootstrap";
import "./NavTextButton.css"

const NavTextButton = ({title}: navButtonProps) => {
    return(
        <Nav.Item>
            <Nav.Link href={'#' + title} className="mb-6 ps-5 pe-5 fs-4 navtextcolor">{title}</Nav.Link>
        </Nav.Item>
    )
}

export default NavTextButton;